import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFlipHorizontally20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconFlipHorizontally20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m5.654 15.488 9-1.403a1 1 0 0 0 .846-.988v-.922H17v.922a2.5 2.5 0 0 1-2.115 2.47l-9 1.403A2.5 2.5 0 0 1 3 14.5v-2.325h1.5V14.5a1 1 0 0 0 1.154.989M17 7.805h-1.5v-.902a1 1 0 0 0-.846-.988l-9-1.403A1 1 0 0 0 4.5 5.5v2.305H3V5.5a2.5 2.5 0 0 1 2.885-2.47l9 1.403A2.5 2.5 0 0 1 17 6.903zm1.25 2.935a.75.75 0 0 0 0-1.5H1.749a.75.75 0 0 0 0 1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFlipHorizontally20);
